import {createSvgIcon} from '../create-svg-icon';

export const ChatIcon = createSvgIcon(
  <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />,
  'ChatOutlined',
  '0 -960 960 960',
);
